export default {
  colors: {
    obsidian: "#15161b",
    grey1: "#b3bbd4",
    grey4: "#686d7b",
    blue: "#376DF9",
    green: "#5FCA7C",
  },
}
